function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useAction } from 'hooks';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './ReportsLayout.pcss';
const BasicParams = ()=>{
    const hideReadingsTable = useSelector(selectors.hideReadingsTable);
    const onSetHideReadingsTable = useAction(actions.setHideReadingsTable, !hideReadingsTable);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.reportsLayout__reportParams,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.reportsLayout__reportParam,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                        inputValue: "true",
                        value: hideReadingsTable ? 'true' : 'false',
                        onChange: onSetHideReadingsTable
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.reportsLayout__reportParamName,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.reports.labels.hideDailyDetails))
                })
            ]
        })
    });
};
export default BasicParams;
